import {Key} from '../cached/AlphaCatalogue';

export interface FeatureKey extends Key {
  children: FeatureKey[];
  level: number;
}
